// eslint-disable-next-line import/no-cycle
import { getCustomContactProperties } from '@/configs/custom-contact-properties';
import { i18n } from '@/i18n';

/**
 * Build the list of date variable options for the countdown widget.
 * Includes the static voucher.date_end + all custom/metadata contact fields of type date/datetime.
 * Returns a Promise (the Dropdown component awaits options.list).
 */
const getCountdownDateVariableOptions = async (): Promise<{ value: string; label: string; isCustom?: boolean }[]> => {
  const t = (i18n.global as any).t;
  const options: { value: string; label: string; isCustom?: boolean }[] = [
    { value: 'voucher.date_end', label: t('templateBuilder.fields.countdownDateVariableVoucherEnd') },
  ];

  try {
    const customSchemas = await getCustomContactProperties();
    customSchemas.forEach((schema) => {
      schema.properties
        .filter((prop) => prop.type === 'date' || prop.type === 'datetime')
        .forEach((prop) => {
          const label = prop.label || prop.name;
          options.push({
            value: prop.variableName || `contact.custom.${prop.name}`,
            label: `${schema.schemaName} - ${label}`,
            isCustom: true,
          });
        });
    });
  } catch (error) {
    // Silently fail — at minimum the static voucher option is available
  }

  return options;
};

export default getCountdownDateVariableOptions;
